// helpers.ts
export async function hashPassword(password: string): Promise<string> {
  const encoder = new TextEncoder();
  const data = encoder.encode(password);
  const hashBuffer = await crypto.subtle.digest("SHA-256", data);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  return hashArray.map((b) => b.toString(16).padStart(2, "0")).join("");
}
export async function hash256(password: string): Promise<string> {
  // Codificar la contraseña como UTF-8
  const encoder = new TextEncoder();
  const data = encoder.encode(password);
  
  // Calcular el hash SHA-256
  const hashBuffer = await crypto.subtle.digest('SHA-256', data);
  
  // Convertir el ArrayBuffer a array de bytes
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  
  // Convertir bytes a string hexadecimal
  return hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
}

export function generateRandomToken(length = 48): string {
  const arr = new Uint8Array(length);
  crypto.getRandomValues(arr);
  // base64url
  const b64 = btoa(String.fromCharCode.apply(null, Array.from(arr)));
  return b64.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}

export function setCookie(name: string, value: string, days = 7) {
  const d = new Date();
  d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
  document.cookie = `${name}=${value}; path=/; expires=${d.toUTCString()}; SameSite=Lax`;
}
